<app-page-section sectionClass="section-pad" containerClass="container">
  <div class="d-flex flex-column flex-lg-row justify-content-between gap-3 mb-4">
    <div>
      <span class="badge rounded-pill text-bg-primary mb-3">{{ i18n.t('dashboard.badge') }}</span>
      <h1 class="fw-bold mb-2">{{ i18n.t('dashboard.title') }}</h1>
      <p class="lead text-secondary mb-0">{{ i18n.t('dashboard.subtitle') }}</p>
    </div>
  </div>

  @if (isLoadingMatchedOffers) {
    <div class="soft-card bg-white p-5 mb-4" aria-live="polite">
      <app-loading-spinner [label]="i18n.t('common.loadingPage')"></app-loading-spinner>
    </div>
  } @else {
  <div class="row g-4 mb-4 dashboard-stats-row">
    <div class="col-md-6 col-xl-3 dashboard-stat-col">
      <div class="soft-card bg-white p-4 h-100">
        <p class="text-secondary mb-1">{{ i18n.t('dashboard.activeOffers') }}</p>
        <strong class="display-6">{{ activeOffers }}</strong>
      </div>
    </div>
    <div class="col-md-6 col-xl-3 dashboard-stat-col">
      <div class="soft-card bg-white p-4 h-100">
        <p class="text-secondary mb-1">{{ i18n.t('dashboard.averageFit') }}</p>
        <strong class="display-6">{{ averageFit }}%</strong>
      </div>
    </div>
    <div class="col-md-6 col-xl-3 dashboard-stat-col">
      <div class="soft-card bg-white p-4 h-100">
        <p class="text-secondary mb-1">{{ i18n.t('dashboard.appliedOrInterviewed') }}</p>
        <strong class="display-6">{{ appliedOrInterviewed }}</strong>
      </div>
    </div>
    <div class="col-md-6 col-xl-3 dashboard-stat-col">
      <button class="soft-card dashboard-stat-card dashboard-stat-button bg-white p-4 h-100 w-100 text-start" type="button" (click)="openMyContributionsModal()" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.title')">
        <p class="text-secondary mb-1">{{ i18n.t('dashboard.contributions') }}</p>
        <strong class="display-6">{{ contributionCount }}</strong>
      </button>
    </div>
  </div>

  <div class="dashboard-main-tabs mb-4" role="tablist" [attr.aria-label]="i18n.t('dashboard.mainTabs')">
    <button class="dashboard-main-tab" type="button" role="tab" [class.active]="activeMainTab === 'activity'" [attr.aria-selected]="activeMainTab === 'activity'" (click)="setMainTab('activity')">
      <i class="bi bi-kanban me-2" aria-hidden="true"></i>{{ i18n.t('dashboard.activityTab') }}
    </button>
    <button class="dashboard-main-tab" type="button" role="tab" [class.active]="activeMainTab === 'contributors'" [attr.aria-selected]="activeMainTab === 'contributors'" (click)="setMainTab('contributors')">
      <i class="bi bi-trophy me-2" aria-hidden="true"></i>{{ i18n.t('dashboard.topContributorsTab') }}
    </button>
  </div>

  @if (activeMainTab === 'activity') {
  <div class="row g-4">
    <div class="col-xl-8">
      <div class="soft-card bg-white p-4 h-100">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
          <h2 class="h4 mb-0">{{ i18n.t('dashboard.offersByStatus') }}</h2>
          <div class="offers-table-toolbar">
            <span class="text-secondary small">{{ i18n.t('dashboard.orderedByPriority') }}</span>
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="openSearchModal()">
              <i class="bi bi-search me-1"></i>{{ i18n.t('common.search') }}
            </button>
            <label class="pagination-page-size">
              <span>{{ i18n.t('dashboard.rowsPerPage') }}</span>
              <select class="form-select form-select-sm" [ngModel]="offersPageSize" (ngModelChange)="setOffersPageSize($event)" [attr.aria-label]="i18n.t('dashboard.rowsPerOffersPage')">
                @for (pageSize of pageSizeOptions; track pageSize) {
                  <option [ngValue]="pageSize">{{ pageSize }}</option>
                }
              </select>
            </label>
          </div>
        </div>
        <div class="table-responsive offers-table-wrap">
          <table class="table align-middle mb-0 offers-table">
            <thead>
              <tr>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('status')" [attr.aria-sort]="offerSortKey === 'status' ? offerSortDirection : 'none'">
                    {{ i18n.t('common.status') }} <i [class]="'bi ' + sortIcon('status')" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('title')" [attr.aria-sort]="offerSortKey === 'title' ? offerSortDirection : 'none'">
                    {{ i18n.t('common.offer') }} <i [class]="'bi ' + sortIcon('title')" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('university')" [attr.aria-sort]="offerSortKey === 'university' ? offerSortDirection : 'none'">
                    {{ i18n.t('common.university') }} <i [class]="'bi ' + sortIcon('university')" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('country')" [attr.aria-sort]="offerSortKey === 'country' ? offerSortDirection : 'none'">
                    {{ i18n.t('common.country') }} <i [class]="'bi ' + sortIcon('country')" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('fitScore')" [attr.aria-sort]="offerSortKey === 'fitScore' ? offerSortDirection : 'none'">
                    {{ i18n.t('common.fit') }} <i [class]="'bi ' + sortIcon('fitScore')" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('publishedAt')" [attr.aria-sort]="offerSortKey === 'publishedAt' ? offerSortDirection : 'none'">
                    {{ i18n.t('dashboard.publishedAt') }} <i [class]="'bi ' + sortIcon('publishedAt')" aria-hidden="true"></i>
                  </button>
                </th>
                <th scope="col">
                  <button class="table-sort-button" type="button" (click)="setOfferSort('deadline')" [attr.aria-sort]="offerSortKey === 'deadline' ? offerSortDirection : 'none'">
                    {{ i18n.t('common.deadline') }} <i [class]="'bi ' + sortIcon('deadline')" aria-hidden="true"></i>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (offer of paginatedOrderedOffers; track offer.id) {
                <tr class="offer-row" (click)="openOfferDetail(offer)" tabindex="0" role="button" (keyup.enter)="openOfferDetail(offer)">
                  <td class="offer-status-cell"><span class="badge rounded-pill status-badge">{{ offerStatusLabel(offer.status) }}</span></td>
                  <td class="offer-title-cell"><strong class="offer-title-text" [title]="offer.title">{{ offer.title }}</strong></td>
                  <td class="offer-meta-cell offer-university-cell"><span class="offer-meta-text" [class.unknown-inline]="offer.university === 'Unknown organization'" [title]="offer.university">{{ offer.university === 'Unknown organization' ? i18n.t('common.unknown') : offer.university }}</span></td>
                  <td class="offer-meta-cell offer-country-cell">
                    <span class="offer-meta-text country-with-flag" [class.unknown-inline]="isUnknownCountry(offer.country)" [title]="offerCountryTitle(offer)" [attr.aria-label]="offerCountryTitle(offer)">
                      @for (country of countryFlagItems(offer); track country.code) { <img class="country-flag" [src]="country.flagUrl" [alt]="country.name" [title]="country.name" loading="lazy"> }
                      @empty { <span>{{ countryDisplayName(offer.country) }}</span> }
                    </span>
                  </td>
                  <td class="offer-fit-cell"><span>{{ offer.fitScore }}%</span></td>
                  <td class="offer-date-cell offer-published-cell"><span [class.unknown-inline]="!offer.publishedAt || offer.publishedAt === 'unknown'">{{ formatOptionalOfferDate(offer.publishedAt) }}</span></td>
                  <td class="offer-date-cell offer-deadline-cell">
                    @if (isUnknownDeadline(offer.deadline)) {
                      <span class="badge rounded-pill unknown-pill">{{ formatOfferDeadline(offer.deadline) }}</span>
                    } @else {
                      <button class="btn btn-link p-0" type="button" (click)="$event.stopPropagation(); openCalendarModal(offer)">{{ formatOfferDeadline(offer.deadline) }}</button>
                    }
                  </td>
                </tr>
              }
              @empty {
                <tr>
                  <td colspan="7">
                    <div class="dashboard-empty-state" role="status" [attr.aria-live]="isLoadingMatchedOffers ? 'polite' : null">
                      @if (isLoadingMatchedOffers) {
                        <span class="spinner-border text-primary mb-3" aria-hidden="true"></span>
                      } @else if (matchedOffersLoadFailed) {
                        <i class="bi bi-cloud-slash empty-state-icon" aria-hidden="true"></i>
                      } @else if (hasActiveOfferFilters) {
                        <i class="bi bi-funnel empty-state-icon" aria-hidden="true"></i>
                      } @else {
                        <i class="bi bi-inbox empty-state-icon" aria-hidden="true"></i>
                      }
                      <strong>{{ i18n.t(offersEmptyStateTitleKey) }}</strong>
                      <p>{{ i18n.t(offersEmptyStateDescriptionKey) }}</p>
                      @if (hasActiveOfferFilters && !isLoadingMatchedOffers) {
                        <button class="btn btn-sm btn-outline-primary" type="button" (click)="clearOfferFilters()" [disabled]="isClearingOfferFilters" [attr.aria-busy]="isClearingOfferFilters">
                          @if (isClearingOfferFilters) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
                          {{ isClearingOfferFilters ? i18n.t('dashboard.clearingFilters') : i18n.t('common.clear') }}
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <nav class="dashboard-pagination" [attr.aria-label]="i18n.t('dashboard.offersPagination')">
          <div class="pagination-left">
            <button class="pagination-arrow" type="button" (click)="goToPreviousOffersPage()" [disabled]="currentOffersPage === 1" [attr.aria-label]="i18n.t('dashboard.previousOffersPage')">
              <i class="bi bi-chevron-left"></i>
            </button>
            <div class="pagination-pages" [attr.aria-label]="i18n.t('dashboard.availableOfferPages')">
              @for (item of visibleOffersPages; track item.key) {
                <button class="pagination-page" type="button" [class.active]="item.page === currentOffersPage" [disabled]="item.disabled" [attr.aria-current]="item.page === currentOffersPage ? 'page' : null" (click)="item.page && goToOffersPage(item.page)">{{ item.label }}</button>
              }
            </div>
            <button class="pagination-arrow" type="button" (click)="goToNextOffersPage()" [disabled]="currentOffersPage === totalOffersPages" [attr.aria-label]="i18n.t('dashboard.nextOffersPage')">
              <i class="bi bi-chevron-right"></i>
            </button>
            <span class="pagination-summary">{{ i18n.t('dashboard.pageOf', { current: currentOffersPage, total: totalOffersPages }) }}</span>
          </div>
          <div class="pagination-go-to">
            <label class="pagination-custom-page">
              <span>{{ i18n.t('dashboard.goTo') }}</span>
              <input class="form-control form-control-sm" type="number" min="1" [max]="totalOffersPages" [ngModel]="customOffersPage" (ngModelChange)="setCustomOffersPage($event)" (keyup.enter)="goToCustomOffersPage()" [attr.aria-label]="i18n.t('dashboard.customPageNumber')">
            </label>
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="goToCustomOffersPage()">{{ i18n.t('common.go') }}</button>
          </div>
        </nav>
      </div>
    </div>

    <div class="col-xl-4">
      <div class="soft-card bg-white p-4 h-100">
        <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
          <div>
            <h2 class="h4 mb-1">{{ i18n.t('dashboard.tierList') }}</h2>
            <p class="text-secondary small mb-0">{{ i18n.t('dashboard.tierListHelp') }}</p>
          </div>
          <button class="btn btn-sm btn-primary" type="button" (click)="openAddTierOfferModal()" [disabled]="isAddingTierOffer">
            <i class="bi bi-plus-lg me-1"></i>{{ i18n.t('dashboard.addOffer') }}
          </button>
        </div>
        <div class="tiermaker-board">
        @for (tier of tierLanes; track tier.id) {
          <div class="tier-row" (dragover)="allowDrop($event)" (drop)="dropOnTier($event, tier.id)">
            <div class="tier-label" [style.background]="tier.color">
              <input class="tier-name-input" [(ngModel)]="tier.name" [attr.aria-label]="i18n.t('dashboard.renameTier', { tier: tier.id })">
            </div>
            <div class="tier-items">
              @for (offer of offersByTier(tier.id); track offer.id) {
                <span class="tier-chip" draggable="true" (dragstart)="onDragStart($event, offer)" (dragover)="allowDrop($event)" (drop)="dropBeforeOffer($event, offer)" (contextmenu)="openTierContextMenu($event, offer)">{{ offer.title }}</span>
              } @empty {
                <span class="tier-empty-hint">{{ i18n.t('dashboard.dropOrAddOffer') }}</span>
              }
            </div>
          </div>
        }
        </div>
      </div>
    </div>
  </div>
  <div class="soft-card dashboard-chart-card bg-white p-4 mb-4">
    <div class="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center gap-3 mb-4">
      <div>
        <h2 class="h4 mb-1">{{ i18n.t('dashboard.pipelineStats') }}</h2>
        <p class="text-secondary mb-0">{{ i18n.t('dashboard.metricPerDay', { metric: selectedMetricLabel }) }}</p>
      </div>
      <form class="chart-filter" [attr.aria-label]="i18n.t('dashboard.dateRangeFilter')">
        <div class="btn-group flex-wrap" role="group" [attr.aria-label]="i18n.t('dashboard.dateRangePresets')">
          @for (option of rangeOptions; track option.value) {
            <input class="btn-check" type="radio" name="chartRange" [id]="'chartRange' + option.value" [value]="option.value" [ngModel]="selectedRange" (ngModelChange)="setRange($event)">
            <label class="btn btn-outline-primary btn-sm" [for]="'chartRange' + option.value">{{ i18n.t(option.labelKey) }}</label>
          }
        </div>
        @if (selectedRange === 'custom') {
          <div class="custom-date-range">
            <label class="form-label mb-0" for="chartFromDate">{{ i18n.t('dashboard.from') }}</label>
            <input id="chartFromDate" class="form-control form-control-sm" type="date" name="chartFromDate" [max]="today" [ngModel]="customFrom" (ngModelChange)="setCustomFrom($event)">
            <label class="form-label mb-0" for="chartToDate">{{ i18n.t('dashboard.to') }}</label>
            <input id="chartToDate" class="form-control form-control-sm" type="date" name="chartToDate" [max]="today" [ngModel]="customTo" (ngModelChange)="setCustomTo($event)">
          </div>
        }
      </form>
    </div>
    <div class="line-chart" [attr.aria-label]="i18n.t('dashboard.statisticsChart')">
      <button class="chart-fullscreen-button" type="button" (click)="openChartFullscreen()" [attr.aria-label]="i18n.t('dashboard.statisticsChart')">
        <i class="bi bi-arrows-fullscreen" aria-hidden="true"></i>
      </button>
      <div class="chart-metric-tabs" role="tablist" [attr.aria-label]="i18n.t('dashboard.metricTabs')">
        @for (option of metricOptions; track option.value) {
          <input class="btn-check" type="radio" name="chartMetric" [id]="'chartMetric' + option.value" [value]="option.value" [ngModel]="selectedMetric" (ngModelChange)="setMetric($event)">
          <label class="chart-metric-tab" role="tab" [attr.aria-selected]="selectedMetric === option.value" [for]="'chartMetric' + option.value">{{ i18n.t(option.labelKey) }}</label>
        }
      </div>
      <div class="line-chart-plot" (pointermove)="updateCursorGuide($event)" (pointerleave)="hideCursorGuide()">
        @if (activeStatPoint) {
          <div class="chart-tooltip-panel" [style.left.%]="tooltipLeftPercent" aria-live="polite">
            <strong>{{ activeStatPoint.point.day }}</strong>
            <span>{{ selectedMetricLabel }}: {{ selectedMetricTooltipValue(activeStatPoint.point) }}</span>
          </div>
        }
        @if (cursorGuideX !== null) {
          <div class="chart-cursor-guide" [style.left.%]="cursorGuideLeftPercent"></div>
        }
        <svg viewBox="0 0 500 170" preserveAspectRatio="xMidYMid meet" role="img">
          <title>{{ i18n.t('dashboard.chartTitle') }}</title>
          <g class="grid-lines"><line x1="24" y1="18" x2="476" y2="18"></line><line x1="24" y1="78" x2="476" y2="78"></line><line x1="24" y1="138" x2="476" y2="138"></line></g>
          <g class="y-axis-scale" [class.y-axis-scale-fit]="selectedMetric === 'averageFit'" [class.y-axis-scale-offers]="selectedMetric === 'newOffers'" aria-hidden="true"><text x="18" y="18">{{ yAxisMaxLabel }}</text><text x="18" y="78">{{ yAxisMidLabel }}</text><text x="18" y="138">{{ yAxisMinLabel }}</text></g>
          <g class="chart-series">
            <path class="line" [class.line-fit]="selectedMetric === 'averageFit'" [class.line-offers]="selectedMetric === 'newOffers'" [attr.d]="selectedMetricPath"></path>
            @for (point of visibleStatPoints; track point.day; let i = $index) { <circle class="line-point" [class.fit]="selectedMetric === 'averageFit'" [class.offers]="selectedMetric === 'newOffers'" [class.active]="isActiveStatPoint(i)" [attr.cx]="pointX(i)" [attr.cy]="selectedMetricPointY(point)" [attr.r]="isActiveStatPoint(i) ? 4 : 3" (mouseenter)="showPointInfo(point, i)"></circle> }
          </g>
        </svg>
        <div class="line-chart-labels">@for (label of xAxisLabels; track label.index) { <small [class.axis-label-start]="label.align === 'start'" [class.axis-label-end]="label.align === 'end'" [style.left.%]="label.left">{{ label.day }}</small> }</div>
      </div>
    </div>
    <div class="d-flex flex-wrap gap-3 mt-3 small text-secondary"><span><i class="bi bi-square-fill me-1" [class.text-primary]="selectedMetric === 'averageFit'" [class.text-info]="selectedMetric === 'newOffers'"></i>{{ selectedMetricLabel }}</span></div>
  </div>
  } @else {
  <div class="soft-card bg-white p-4 mb-4 top-contributors-card">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
      <div>
        <h2 class="h4 mb-1">{{ i18n.t('dashboard.topContributorsTitle') }}</h2>
        <p class="text-secondary mb-0">{{ i18n.t('dashboard.topContributorsHelp') }}</p>
      </div>
      <button class="btn btn-sm btn-outline-primary" type="button" (click)="loadTopContributors()" [disabled]="isLoadingTopContributors" [attr.aria-busy]="isLoadingTopContributors">
        @if (isLoadingTopContributors) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-arrow-clockwise me-1" aria-hidden="true"></i> }
        {{ i18n.t('dashboard.refreshTopContributors') }}
      </button>
    </div>
    <div class="leaderboard-board-tabs mb-3" role="tablist" [attr.aria-label]="i18n.t('dashboard.leaderboardTabs')">
      @for (board of leaderboardBoards; track board.value) {
        <button class="leaderboard-board-tab" type="button" role="tab" [class.active]="selectedLeaderboardBoard === board.value" [attr.aria-selected]="selectedLeaderboardBoard === board.value" (click)="setLeaderboardBoard(board.value)">{{ i18n.t(board.labelKey) }}</button>
      }
    </div>
    @if (isLoadingTopContributors) {
      <app-loading-spinner [label]="i18n.t('dashboard.loadingTopContributors')"></app-loading-spinner>
    } @else if (topContributorsLoadFailed) {
      <div class="dashboard-empty-state">
        <i class="bi bi-cloud-slash empty-state-icon" aria-hidden="true"></i>
        <strong>{{ i18n.t('dashboard.topContributorsErrorTitle') }}</strong>
        <p>{{ i18n.t('dashboard.topContributorsErrorDescription') }}</p>
      </div>
    } @else {
      <div class="top-contributors-list">
        @for (contributor of topContributors; track contributor.rank) {
          <div class="top-contributor-row" [class.top-three]="contributor.rank <= 3" [class.current-user]="contributor.isCurrentUser">
            <div class="contributor-avatar" [class.avatar-image-loading]="isContributorAvatarLoading(contributor)">
              @if (safeImageUrl(contributor.avatar)) { <img [src]="safeImageUrl(contributor.avatar)" [alt]="contributor.displayName" loading="lazy" referrerpolicy="no-referrer" [attr.data-avatar-key]="contributorAvatarKey(contributor)" (load)="onContributorAvatarLoad(contributorAvatarKey(contributor))" (error)="onContributorAvatarError($event)"> }
              <span class="avatar-initials">{{ contributorInitials(contributor) }}</span>
              @if (isContributorAvatarLoading(contributor)) { <span class="contributor-avatar-spinner spinner-border spinner-border-sm" aria-hidden="true"></span> }
              <span class="top-contributor-rank">{{ rankMedal(contributor.rank) }}</span>
            </div>
            <div class="top-contributor-main">
              <strong>{{ contributor.displayName }}</strong>
              <span>{{ i18n.t('dashboard.topContributorStats', { proposals: contributor.proposalCount, votes: contributor.reviewCount }) }}</span>
              @if (contributor.badges?.length) { <div class="contributor-badges image-badges">@for (badge of contributor.badges; track badge.key) { <span class="contributor-badge" [title]="badgeLabel(badge)"><img [src]="badgeImageUrl(badge)" [alt]="badgeAlt(badge)" loading="lazy"><span>{{ badgeLabel(badge) }}</span></span> }</div> }
            </div>
            <div class="top-contributor-metrics top-contributor-score-metric">
              <button class="score-chip" type="button" (click)="openScoreDetails(contributor)"><i class="bi bi-stars me-1" aria-hidden="true"></i>{{ contributor.score }}</button>
              <small>{{ i18n.t('dashboard.contributorScore') }}</small>
            </div>
            <div class="top-contributor-metrics top-contributor-likes-metric">
              <span><i class="bi bi-hand-thumbs-up me-1" aria-hidden="true"></i>{{ contributor.receivedLikeCount }}</span>
              <small>{{ i18n.t('dashboard.receivedLikes') }}</small>
            </div>
          </div>
        } @empty {
          <div class="dashboard-empty-state">
            <i class="bi bi-trophy empty-state-icon" aria-hidden="true"></i>
            <strong>{{ i18n.t('dashboard.noTopContributorsTitle') }}</strong>
            <p>{{ i18n.t('dashboard.noTopContributorsDescription') }}</p>
          </div>
        }
        @if (topContributorsResponse?.currentUser; as currentUser) {
          <div class="your-position-label">{{ i18n.t('dashboard.yourPosition') }}</div>
          <div class="top-contributor-row current-user separated">
            <div class="contributor-avatar" [class.avatar-image-loading]="isContributorAvatarLoading(currentUser)">
              @if (safeImageUrl(currentUser.avatar)) { <img [src]="safeImageUrl(currentUser.avatar)" [alt]="currentUser.displayName" loading="lazy" referrerpolicy="no-referrer" [attr.data-avatar-key]="contributorAvatarKey(currentUser)" (load)="onContributorAvatarLoad(contributorAvatarKey(currentUser))" (error)="onContributorAvatarError($event)"> }
              <span class="avatar-initials">{{ contributorInitials(currentUser) }}</span>
              @if (isContributorAvatarLoading(currentUser)) { <span class="contributor-avatar-spinner spinner-border spinner-border-sm" aria-hidden="true"></span> }
              <span class="top-contributor-rank">#{{ currentUser.rank }}</span>
            </div>
            <div class="top-contributor-main">
              <strong>{{ currentUser.displayName }}</strong>
              <span>{{ i18n.t('dashboard.topContributorStats', { proposals: currentUser.proposalCount, votes: currentUser.reviewCount }) }}</span>
              @if (currentUser.badges?.length) { <div class="contributor-badges image-badges">@for (badge of currentUser.badges; track badge.key) { <span class="contributor-badge" [title]="badgeLabel(badge)"><img [src]="badgeImageUrl(badge)" [alt]="badgeAlt(badge)" loading="lazy"><span>{{ badgeLabel(badge) }}</span></span> }</div> }
            </div>
            <div class="top-contributor-metrics top-contributor-score-metric"><button class="score-chip" type="button" (click)="openScoreDetails(currentUser)"><i class="bi bi-stars me-1" aria-hidden="true"></i>{{ currentUser.score }}</button><small>{{ i18n.t('dashboard.contributorScore') }}</small></div>
            <div class="top-contributor-metrics top-contributor-likes-metric"><span><i class="bi bi-hand-thumbs-up me-1" aria-hidden="true"></i>{{ currentUser.receivedLikeCount }}</span><small>{{ i18n.t('dashboard.receivedLikes') }}</small></div>
          </div>
        }
      </div>
    }
  </div>
  }


  }
</app-page-section>

@if (showSearchModal) {
  <div class="modal-backdrop-custom" [class.modal-is-opening]="!isModalClosing('search')" [class.modal-is-closing]="isModalClosing('search')" (click)="closeSearchModal()"></div>
  <div class="calendar-modal search-modal" [class.modal-is-opening]="!isModalClosing('search')" [class.modal-is-closing]="isModalClosing('search')" role="dialog" aria-modal="true" aria-labelledby="offerSearchModalTitle">
    <div class="soft-card bg-white modal-card-shell">
      <div class="modal-fixed-header d-flex justify-content-between align-items-start gap-3">
        <div>
          <h2 id="offerSearchModalTitle" class="h4 mb-1">{{ i18n.t('dashboard.searchOffers') }}</h2>
          <p class="text-secondary mb-0">{{ i18n.t('dashboard.searchHelp') }}</p>
        </div>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="closeSearchModal()" [attr.aria-label]="i18n.t('dashboard.closeSearchModal')"><i class="bi bi-x-lg"></i></button>
      </div>
      <form class="offer-search-grid modal-scroll-body" (ngSubmit)="applyOfferFilters()">
        <label class="form-label">
          {{ i18n.t('common.status') }}
          <input class="form-control" type="text" [ngModel]="draftOfferFilters.status" name="filterStatus" (ngModelChange)="setDraftOfferFilter('status', $event)" [placeholder]="i18n.t('dashboard.placeholders.status')">
        </label>
        <label class="form-label">
          {{ i18n.t('common.offer') }}
          <input class="form-control" type="text" [ngModel]="draftOfferFilters.title" name="filterTitle" (ngModelChange)="setDraftOfferFilter('title', $event)" [placeholder]="i18n.t('dashboard.placeholders.offer')">
        </label>
        <label class="form-label">
          {{ i18n.t('common.university') }}
          <input class="form-control" type="text" [ngModel]="draftOfferFilters.university" name="filterUniversity" (ngModelChange)="setDraftOfferFilter('university', $event)" [placeholder]="i18n.t('dashboard.placeholders.university')">
        </label>
        <label class="form-label">
          {{ i18n.t('common.country') }}
          <input class="form-control" type="text" [ngModel]="draftOfferFilters.country" name="filterCountry" (ngModelChange)="setDraftOfferFilter('country', $event)" [placeholder]="i18n.t('dashboard.placeholders.country')">
        </label>
        <label class="form-label">
          {{ i18n.t('common.fit') }}
          <input class="form-control" type="text" [ngModel]="draftOfferFilters.fitScore" name="filterFit" (ngModelChange)="setDraftOfferFilter('fitScore', $event)" [placeholder]="i18n.t('dashboard.placeholders.fit')">
        </label>
        <label class="form-label">
          {{ i18n.t('common.deadline') }}
          <input class="form-control" type="text" [ngModel]="draftOfferFilters.deadline" name="filterDeadline" (ngModelChange)="setDraftOfferFilter('deadline', $event)" [placeholder]="i18n.t('dashboard.placeholders.deadline')">
        </label>
        <div class="offer-search-actions">
          <button class="btn btn-primary" type="submit" [disabled]="isApplyingOfferFilters || isClearingOfferFilters" [attr.aria-busy]="isApplyingOfferFilters">
            @if (isApplyingOfferFilters) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
            {{ isApplyingOfferFilters ? i18n.t('dashboard.applyingFilters') : i18n.t('dashboard.applyFilters') }}
          </button>
          <button class="btn btn-outline-secondary" type="button" (click)="clearOfferFilters()" [disabled]="isApplyingOfferFilters || isClearingOfferFilters" [attr.aria-busy]="isClearingOfferFilters">
            @if (isClearingOfferFilters) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
            {{ isClearingOfferFilters ? i18n.t('dashboard.clearingFilters') : i18n.t('common.clear') }}
          </button>
          <button class="btn btn-link" type="button" (click)="closeSearchModal()" [disabled]="isApplyingOfferFilters || isClearingOfferFilters">{{ i18n.t('common.cancel') }}</button>
        </div>
      </form>
    </div>
  </div>
}

@if (selectedOfferDetail) {
  <div class="modal-backdrop-custom" [class.modal-is-opening]="!isModalClosing('offerDetail')" [class.modal-is-closing]="isModalClosing('offerDetail')" (click)="closeOfferDetail()"></div>
  <div class="calendar-modal offer-detail-modal" [class.offer-detail-modal-scrolled]="isOfferDetailScrolled" [class.offer-detail-modal-blurred]="selectedContributionField" [class.modal-is-opening]="!isModalClosing('offerDetail')" [class.modal-is-closing]="isModalClosing('offerDetail')" role="dialog" aria-modal="true" aria-labelledby="offerDetailTitle">
    <div class="offer-detail-shell">
      <div class="offer-detail-hero">
        <div class="offer-detail-hero-content">
          <span class="offer-fit-pill"><i class="bi bi-stars me-1"></i>{{ i18n.t('dashboard.fitBadge', { fit: selectedOfferDetail.fitScore }) }}</span>
          <h2 id="offerDetailTitle">
            @if (safeExternalUrl(selectedOfferDetail.applyUrl) || safeExternalUrl(selectedOfferDetail.sourceUrl)) {
              <a class="offer-title-link" [href]="safeExternalUrl(selectedOfferDetail.applyUrl) || safeExternalUrl(selectedOfferDetail.sourceUrl)" target="_blank" rel="noopener noreferrer">{{ selectedOfferDetail.title }} <i class="bi bi-box-arrow-up-right"></i></a>
            } @else {
              {{ selectedOfferDetail.title }}
            }
          </h2>
          <div class="offer-detail-meta-line">
            <span><i class="bi bi-building me-1"></i>{{ selectedOfferDetail.university }}</span>
            <span>
              @for (country of countryFlagItems(selectedOfferDetail); track country.code) { <img class="country-flag" [src]="country.flagUrl" [alt]="country.name" [title]="country.name" loading="lazy"> }
              @if (!isMultipleCountries(selectedOfferDetail.country)) { {{ countryDisplayName(selectedOfferDetail.country) }} }
            </span>
            <span><i class="bi bi-diagram-3 me-1"></i>{{ selectedOfferDetail.department || i18n.t('common.unknown') }}</span>
          </div>
        </div>
        <button class="offer-detail-close" type="button" (click)="closeOfferDetail()" [attr.aria-label]="i18n.t('dashboard.offerDetails.close')"><i class="bi bi-x-lg"></i></button>
      </div>

      <div class="offer-detail-body" (scroll)="onOfferDetailBodyScroll($event)">
      <section class="offer-detail-panel offer-summary-panel offer-layout-summary">
        <div class="section-kicker"><i class="bi bi-card-text me-2"></i>{{ i18n.t('dashboard.offerDetails.overview') }}</div>
        <p class="offer-description mb-0">{{ selectedOfferDetail.description || i18n.t('common.unknown') }}</p>
      </section>
        <div class="offer-action-row offer-layout-actions">
          <label class="offer-status-control"><span>{{ i18n.t('common.status') }}</span><select class="form-select form-select-sm mt-1" [ngModel]="selectedOfferDetail.status" (ngModelChange)="updateSelectedOfferStatus($event)">
            @for (status of statusOptions; track status) { <option [ngValue]="status">{{ offerStatusLabel(status) }}</option> }
          </select></label>
          @if (safeExternalUrl(selectedOfferDetail.applyUrl)) {
            <a class="btn btn-primary" [href]="safeExternalUrl(selectedOfferDetail.applyUrl)" target="_blank" rel="noopener noreferrer"><i class="bi bi-box-arrow-up-right me-2"></i>{{ i18n.t('dashboard.offerDetails.applyLink') }}</a>
          }
          @if (safeExternalUrl(selectedOfferDetail.sourceUrl)) {
            <a class="btn btn-outline-primary" [href]="safeExternalUrl(selectedOfferDetail.sourceUrl)" target="_blank" rel="noopener noreferrer"><i class="bi bi-link-45deg me-2"></i>{{ i18n.t('dashboard.offerDetails.sourceLink') }}</a>
          }
          <div class="offer-cover-letter-actions">
            <div class="small text-secondary" aria-live="polite">{{ coverLetterQuotaLabel }}</div>
            <button class="btn btn-outline-primary" type="button" (click)="generateCoverLetter(selectedOfferDetail)" [disabled]="isGeneratingCoverLetter || isLoadingCoverLetterQuota || !canRequestCoverLetter" [attr.aria-busy]="isGeneratingCoverLetter">
              @if (isGeneratingCoverLetter) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-stars me-2"></i> }
              {{ isGeneratingCoverLetter ? i18n.t('dashboard.generatingCoverLetter') : (!canRequestCoverLetter ? i18n.t('dashboard.coverLetterQuotaExhausted') : i18n.t('dashboard.generateCoverLetter')) }}
            </button>
            @if (coverLetterRequestMessageKey) { <div class="alert alert-info py-2 mb-0">{{ i18n.t(coverLetterRequestMessageKey) }}</div> }
            @if (isLoadingGeneratedCoverLetter) { <div class="small text-secondary"><span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>{{ i18n.t('dashboard.loadingGeneratedCoverLetter') }}</div> }
          </div>
        </div>
      <div class="offer-detail-grid offer-metadata-grid offer-layout-info">
        <div class="offer-info-tile"><span>{{ i18n.t('common.deadline') }}</span><strong [class.unknown-inline]="isUnknownDeadline(selectedOfferDetail.deadline)">{{ formatOfferDeadline(selectedOfferDetail.deadline) }}</strong></div>
        <div class="offer-info-tile"><span>{{ i18n.t('dashboard.publishedAt') }}</span><strong [class.unknown-inline]="!selectedOfferDetail.publishedAt || selectedOfferDetail.publishedAt === 'unknown'">{{ formatOptionalOfferDate(selectedOfferDetail.publishedAt) }}</strong></div>
        <div class="offer-info-tile"><span>{{ i18n.t('dashboard.lastRefreshedAt') }}</span><strong [class.unknown-inline]="!selectedOfferDetail.lastRefreshedAt || selectedOfferDetail.lastRefreshedAt === 'unknown'">{{ formatOptionalOfferDate(selectedOfferDetail.lastRefreshedAt) }}</strong></div>
        <div class="offer-info-tile offer-research-areas-tile"><span>{{ i18n.t('dashboard.offerDetails.researchAreas') }}</span><div class="tag-list compact-tags">@for (tag of selectedOfferDetail.researchAreas ?? ['unknown']; track tag) { <span [class.unknown-pill]="tag === 'unknown'">{{ tag === 'unknown' ? i18n.t('common.unknown') : tag }}</span> }</div></div>
        <div class="offer-info-tile offer-requirements-tile"><span><i class="bi bi-check2-square me-2"></i>{{ i18n.t('dashboard.offerDetails.requirements') }}</span><ul class="requirements-list mb-0 mt-1">@for (requirement of selectedOfferDetail.requirements ?? []; track requirement) { <li>{{ requirement }}</li> }</ul></div>
      </div>

      <section class="offer-detail-panel score-breakdown offer-layout-score">
        <span class="section-kicker"><i class="bi bi-bar-chart me-2"></i>{{ i18n.t('dashboard.offerDetails.scoreDetails') }}</span>
        @for (score of selectedOfferDetail.scoreBreakdown ?? []; track score.label) { <div class="score-row"><span>{{ score.label }}</span><div class="progress"><div class="progress-bar" [style.width.%]="score.value">{{ score.value }}%</div></div><small>{{ score.rationale }}</small></div> }
      </section>

      <section class="offer-detail-panel contribution-panel offer-layout-contribution">
          <div class="offer-section-heading">
            <div>
              <span class="section-kicker"><i class="bi bi-people me-2"></i>{{ i18n.t('dashboard.contributionModal.communityContributions') }}</span>
              <p>{{ i18n.t('dashboard.contributionModal.panelHelp') }}</p>
            </div>
            @if (isLoadingOfferContributions) { <span class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></span> }
          </div>
          @if (!canContributeOfferInfo) {
            <div class="alert alert-warning py-2 mb-0">{{ i18n.t('dashboard.contributionModal.paidPlansOnly') }}</div>
          } @else {
            <div class="contribution-field-list">
              @for (field of contributionFields; track field.key) {
                <div class="contribution-field-row" [class.missing]="field.missing">
                  <div>
                    <strong>{{ field.label }}</strong>
                    <span>{{ contributionCurrentValue(field) }}</span>
                  </div>
                  <button class="btn btn-sm btn-outline-primary" type="button" (click)="openContributionModal(field)">
                    <i class="bi bi-pencil-square me-1"></i>{{ i18n.t('dashboard.contributionModal.suggest') }}
                  </button>
                </div>
              }
            </div>
            @if (contributionMessage) { <div class="small text-secondary" aria-live="polite">{{ contributionMessage }}</div> }
          }
        </section>
      @if (generatedCoverLetter) {
      <section class="offer-detail-panel cover-letter-panel offer-layout-cover-letter">
        <label class="form-label mt-3 w-100">
          <strong>{{ i18n.t('dashboard.generatedCoverLetterDraft') }}</strong>
          <textarea class="form-control mt-2" rows="10" [(ngModel)]="coverLetterDraft" name="coverLetterDraft" [disabled]="isSavingCoverLetter" [attr.aria-label]="i18n.t('dashboard.generatedCoverLetterDraft')"></textarea>
        </label>
        <button class="btn btn-outline-primary" type="button" (click)="saveCoverLetterDraft()" [disabled]="isSavingCoverLetter || !coverLetterDraft.trim()" [attr.aria-busy]="isSavingCoverLetter">
          @if (isSavingCoverLetter) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
          {{ isSavingCoverLetter ? i18n.t('dashboard.savingCoverLetter') : i18n.t('dashboard.saveCoverLetter') }}
        </button>
        <button class="btn btn-outline-secondary ms-2" type="button" (click)="exportCoverLetterTxt()" [disabled]="isExportingCoverLetterTxt || !coverLetterDraft.trim()" [attr.aria-busy]="isExportingCoverLetterTxt">
          @if (isExportingCoverLetterTxt) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-filetype-txt me-2"></i> }
          {{ isExportingCoverLetterTxt ? i18n.t('dashboard.exportingCoverLetterTxt') : i18n.t('dashboard.exportCoverLetterTxt') }}
        </button>
        <button class="btn btn-outline-secondary ms-2" type="button" (click)="exportCoverLetterPdf()" [disabled]="isExportingCoverLetterPdf || !coverLetterDraft.trim()" [attr.aria-busy]="isExportingCoverLetterPdf">
          @if (isExportingCoverLetterPdf) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-filetype-pdf me-2"></i> }
          {{ isExportingCoverLetterPdf ? i18n.t('dashboard.exportingCoverLetterPdf') : i18n.t('dashboard.exportCoverLetterPdf') }}
        </button>
      </section>
      }
      </div>
    </div>
  </div>
}

@if (selectedOfferDetail && selectedContributionField) {
  <div class="modal-backdrop-custom suggestion-modal-backdrop" [class.modal-is-opening]="!isModalClosing('contribution')" [class.modal-is-closing]="isModalClosing('contribution')" (click)="closeContributionModal()"></div>
  <div class="calendar-modal contribution-modal" [class.modal-is-opening]="!isModalClosing('contribution')" [class.modal-is-closing]="isModalClosing('contribution')" role="dialog" aria-modal="true" aria-labelledby="contributionModalTitle">
    <div class="contribution-modal-shell">
      <div class="contribution-modal-header">
        <div>
          <h2 id="contributionModalTitle" class="h4 mb-1">{{ i18n.t('dashboard.contributionModal.title', { field: selectedContributionField.label }) }}</h2>
          <p class="text-secondary mb-0">{{ i18n.t('dashboard.contributionModal.help') }}</p>
        </div>
        <button class="offer-detail-close" type="button" (click)="closeContributionModal()" [disabled]="isSubmittingContribution" [attr.aria-label]="i18n.t('dashboard.contributionModal.close')"><i class="bi bi-x-lg"></i></button>
      </div>

      <div class="contribution-modal-body">
        <div class="contribution-current-value mb-3">
          <span class="small text-secondary">{{ i18n.t('dashboard.contributionModal.currentValue') }}</span>
          <strong>{{ contributionCurrentValue(selectedContributionField) }}</strong>
          @if (isOfferLinkContributionField(selectedContributionField)) {
            <button class="contribution-offer-link" type="button" (click)="returnToOfferModalFromContribution()">
              <i class="bi bi-window-sidebar me-1" aria-hidden="true"></i>{{ i18n.t('dashboard.contributionModal.openOfferModal') }}
            </button>
          }
        </div>

        <div class="mb-3">
        <strong>{{ i18n.t('dashboard.contributionModal.topContributions') }}</strong>
        <div class="contribution-proposals mt-2">
          @for (proposal of topContributionProposals; track proposal.value) {
            <div class="contribution-proposal">
              <div>
                <strong>{{ proposal.value }}</strong>
                <span class="text-secondary small">{{ contributionProposalStats(proposal) }}</span>
                @if (isOfferLinkContributionField(selectedContributionField)) {
                  <button class="contribution-offer-link" type="button" (click)="returnToOfferModalFromContribution()">
                    <i class="bi bi-window-sidebar me-1" aria-hidden="true"></i>{{ i18n.t('dashboard.contributionModal.openOfferModal') }}
                  </button>
                }
              </div>
              <div class="btn-group btn-group-sm" role="group" [attr.aria-label]="i18n.t('dashboard.contributionModal.reactionGroup')">
                <button class="btn" [class.btn-primary]="proposal.votedByCurrentUser" [class.btn-outline-primary]="!proposal.votedByCurrentUser" type="button" (click)="reactToContribution(proposal, 'like')" [disabled]="proposal.votedByCurrentUser || isSubmittingContribution">
                  <i class="bi bi-hand-thumbs-up me-1"></i>{{ proposal.voteCount }}
                </button>
                <button class="btn" [class.btn-danger]="proposal.dislikedByCurrentUser" [class.btn-outline-danger]="!proposal.dislikedByCurrentUser" type="button" (click)="reactToContribution(proposal, 'dislike')" [disabled]="proposal.dislikedByCurrentUser || isSubmittingContribution">
                  <i class="bi bi-hand-thumbs-down me-1"></i>{{ proposal.dislikeCount ?? 0 }}
                </button>
              </div>
            </div>
          } @empty {
            <p class="text-secondary mb-0">{{ i18n.t('dashboard.contributionModal.empty') }}</p>
          }
        </div>
        </div>

        <form (ngSubmit)="submitSelectedContribution()">
        <label class="form-label w-100">
          {{ i18n.t('dashboard.contributionModal.newContribution') }}
          @if (selectedContributionField.key === 'country') {
            <select class="form-select mt-1" [(ngModel)]="contributionDrafts.country" name="contributionDraftCountry" [disabled]="isSubmittingContribution">
              <option value="">{{ i18n.t('dashboard.contributionModal.selectCountry') }}</option>
              @for (country of countryContributionOptions; track country.code) {
                <option [ngValue]="country.value">{{ country.name }}</option>
              }
            </select>
          } @else {
            <input class="form-control mt-1" type="text" [(ngModel)]="contributionDrafts[selectedContributionField.key]" [name]="'contributionDraft' + selectedContributionField.key" [placeholder]="selectedContributionField.placeholder" [disabled]="isSubmittingContribution">
          }
        </label>
        <div class="d-flex flex-column flex-sm-row gap-2 align-items-sm-center mt-3">
          <button class="btn btn-primary" type="submit" [disabled]="isSubmittingContribution || !contributionDrafts[selectedContributionField.key].trim()" [attr.aria-busy]="isSubmittingContribution">
            @if (isSubmittingContribution) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
            {{ i18n.t('dashboard.contributionModal.send') }}
          </button>
          <button class="btn btn-outline-secondary" type="button" (click)="closeContributionModal()" [disabled]="isSubmittingContribution">{{ i18n.t('common.cancel') }}</button>
          @if (contributionMessage) { <span class="small text-secondary" aria-live="polite">{{ contributionMessage }}</span> }
        </div>
        </form>
      </div>
    </div>
  </div>
}

@if (showMyContributionsModal) {
  <div class="modal-backdrop-custom" [class.modal-is-opening]="!isModalClosing('myContributions')" [class.modal-is-closing]="isModalClosing('myContributions')" (click)="closeMyContributionsModal()"></div>
  <div class="calendar-modal my-contributions-modal" [class.modal-is-opening]="!isModalClosing('myContributions')" [class.modal-is-closing]="isModalClosing('myContributions')" role="dialog" aria-modal="true" aria-labelledby="myContributionsModalTitle">
    <div class="soft-card bg-white modal-card-shell">
      <div class="modal-fixed-header d-flex justify-content-between align-items-start gap-3">
        <div>
          <h2 id="myContributionsModalTitle" class="h4 mb-1">{{ i18n.t('dashboard.myContributionsModal.title') }}</h2>
          <p class="text-secondary mb-0">{{ i18n.t('dashboard.myContributionsModal.subtitle', { total: myContributionsTotalItems }) }}</p>
        </div>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="closeMyContributionsModal()" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.close')"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="modal-scroll-body">
        <div class="my-contributions-tabs mb-3" role="tablist" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.tabsLabel')">
          @for (tab of myContributionsTabs; track tab.value) {
            <button class="leaderboard-board-tab" type="button" role="tab" [class.active]="activeMyContributionsTab === tab.value" [attr.aria-selected]="activeMyContributionsTab === tab.value" [disabled]="isLoadingMyContributions" (click)="setMyContributionsTab(tab.value)">
              {{ i18n.t(tab.labelKey) }}
            </button>
          }
        </div>
        @if (isLoadingMyContributions && !myContributions.length) {
          <app-loading-spinner [label]="i18n.t('dashboard.myContributionsModal.loading')"></app-loading-spinner>
        } @else if (myContributionsLoadFailed) {
          <div class="dashboard-empty-state">
            <i class="bi bi-cloud-slash empty-state-icon" aria-hidden="true"></i>
            <strong>{{ i18n.t('dashboard.myContributionsModal.errorTitle') }}</strong>
            <p>{{ i18n.t('dashboard.myContributionsModal.errorDescription') }}</p>
            <button class="btn btn-sm btn-outline-primary" type="button" (click)="loadMyContributions(currentMyContributionsPage)">{{ i18n.t('common.retry') }}</button>
          </div>
        } @else {
          <div class="user-contribution-list my-contribution-list compact-my-contributions">
            @for (contribution of myContributions; track contribution.offerId + contribution.field + contribution.value) {
              <article class="user-contribution-row">
                <div class="user-contribution-main">
                  <span class="user-contribution-field">{{ contributionFieldLabel(contribution.field) }}</span>
                  <strong class="user-contribution-value">{{ contribution.value }}</strong>
                  <small>{{ i18n.t('dashboard.myContributionsModal.sentOn', { date: myContributionDate(contribution) }) }}</small>
                </div>
                <div class="user-contribution-ratio">
                  <span class="positive"><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i>{{ contribution.voteCount }}</span>
                  <span class="negative"><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i>{{ contribution.dislikeCount }}</span>
                </div>
                <button class="btn btn-sm btn-outline-primary my-contribution-open-offer" type="button" (click)="openOfferDetailFromContributionSummary(contribution)" [title]="contributionOfferLabel(contribution)">
                  <i class="bi bi-window-sidebar me-1" aria-hidden="true"></i>{{ i18n.t('dashboard.myContributionsModal.openOffer') }}
                </button>
              </article>
            } @empty {
              <div class="dashboard-empty-state">
                <i class="bi bi-inbox empty-state-icon" aria-hidden="true"></i>
                <strong>{{ i18n.t(myContributionsEmptyTitleKey()) }}</strong>
                <p>{{ i18n.t(myContributionsEmptyDescriptionKey()) }}</p>
              </div>
            }
          </div>
          @if (myContributionsTotalPages > 1) {
            <nav class="dashboard-pagination my-contributions-pagination" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.pagination')">
              <div class="pagination-left">
                <button class="pagination-arrow" type="button" (click)="goToPreviousMyContributionsPage()" [disabled]="currentMyContributionsPage === 1 || isLoadingMyContributions" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.previousPage')"><i class="bi bi-chevron-left"></i></button>
                <div class="pagination-pages" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.availablePages')">
                  @for (item of visibleMyContributionsPages; track item.key) {
                    <button class="pagination-page" type="button" [class.active]="item.page === currentMyContributionsPage" [disabled]="item.disabled || isLoadingMyContributions" [attr.aria-current]="item.page === currentMyContributionsPage ? 'page' : null" (click)="item.page && goToMyContributionsPage(item.page)">{{ item.label }}</button>
                  }
                </div>
                <button class="pagination-arrow" type="button" (click)="goToNextMyContributionsPage()" [disabled]="currentMyContributionsPage === myContributionsTotalPages || isLoadingMyContributions" [attr.aria-label]="i18n.t('dashboard.myContributionsModal.nextPage')"><i class="bi bi-chevron-right"></i></button>
                <span class="pagination-summary">{{ i18n.t('dashboard.pageOf', { current: currentMyContributionsPage, total: myContributionsTotalPages }) }}</span>
              </div>
            </nav>
          }
        }
      </div>
    </div>
  </div>
}

@if (selectedScoreContributor) {
  <div class="modal-backdrop-custom" [class.modal-is-opening]="!isModalClosing('scoreDetails')" [class.modal-is-closing]="isModalClosing('scoreDetails')" (click)="closeScoreDetails()"></div>
  <div class="calendar-modal score-details-modal" [class.modal-is-opening]="!isModalClosing('scoreDetails')" [class.modal-is-closing]="isModalClosing('scoreDetails')" role="dialog" aria-modal="true" aria-labelledby="scoreDetailsTitle">
    <div class="score-details-shell">
      <header class="score-details-hero">
        <div class="score-details-identity">
          <div class="contributor-avatar large score-details-avatar">@if (safeImageUrl(selectedScoreContributor.avatar)) { <img [src]="safeImageUrl(selectedScoreContributor.avatar)" [alt]="selectedScoreContributor.displayName"> } @else { <span>{{ contributorInitials(selectedScoreContributor) }}</span> }</div>
          <div>
            <span class="score-details-eyebrow">{{ i18n.t('dashboard.scoreModal.eyebrow') }}</span>
            <h2 id="scoreDetailsTitle">{{ selectedScoreContributor.displayName }}</h2>
            <p>{{ i18n.t('dashboard.scoreModal.rankBoard', { rank: selectedScoreContributor.rank, board: selectedLeaderboardLabel() }) }}</p>
          </div>
        </div>
        <div class="score-details-total" [attr.aria-label]="i18n.t('dashboard.scoreModal.totalScore')">
          <span>{{ i18n.t('dashboard.scoreModal.totalScore') }}</span>
          <strong>{{ selectedScoreContributor.score }}</strong>
        </div>
        <button class="score-details-close" type="button" (click)="closeScoreDetails()" [attr.aria-label]="i18n.t('dashboard.scoreModal.close')"><i class="bi bi-x-lg"></i></button>
      </header>

      <div class="score-details-body">
        @if (selectedScoreContributor.badges?.length) {
          <section class="score-panel score-badge-panel" [attr.aria-label]="i18n.t('dashboard.scoreModal.badges')">
            <div class="score-panel-heading"><span>{{ i18n.t('dashboard.scoreModal.badges') }}</span><strong>{{ selectedScoreContributor.badges?.length }}</strong></div>
            <div class="contributor-badges image-badges large-badges">@for (badge of selectedScoreContributor.badges; track badge.key) { <span class="contributor-badge" [title]="badgeLabel(badge)"><img [src]="badgeImageUrl(badge)" [alt]="badgeAlt(badge)" loading="lazy"><span>{{ badgeLabel(badge) }}</span></span> }</div>
          </section>
        }

        <section class="score-stat-grid upgraded">
          @for (metric of scoreMetricCards(selectedScoreContributor); track metric.key) {
            <div class="score-stat-card">
              <i [class]="'bi ' + metric.icon" aria-hidden="true"></i>
              <span>{{ i18n.t(metric.labelKey) }}</span>
              <strong>{{ metric.value }}</strong>
            </div>
          }
        </section>

        <section class="score-panel score-component-panel score-component-chart">
          <div class="score-panel-heading chart-title-with-help">
            <span>{{ i18n.t('dashboard.scoreModal.componentsTitle') }} <i class="bi bi-info-circle" [title]="i18n.t('dashboard.scoreModal.formula')" aria-hidden="true"></i></span>
            <strong>{{ selectedScoreContributor.score }} / {{ scoreCompositionTarget(selectedScoreContributor) }} pts</strong>
          </div>
          <div class="score-composition-track" role="img" [attr.aria-label]="i18n.t('dashboard.scoreModal.componentsChartLabel')">
            @for (segment of scoreCompositionSegments(selectedScoreContributor); track segment.key) {
              @if (segment.width > 0) { <div class="score-composition-segment" [style.width.%]="segment.width" [style.background]="segment.color"><span>{{ segment.points > 0 ? '+' + segment.points : segment.points }}</span></div> }
            }
          </div>
          <div class="score-composition-total"><strong>{{ selectedScoreContributor.score }}</strong><span>/ {{ scoreCompositionTarget(selectedScoreContributor) }} pts</span></div>
          <div class="score-composition-breakdown">
            @for (segment of scoreCompositionSegments(selectedScoreContributor); track segment.key) {
              <span class="score-breakdown-item"><i [style.background]="segment.color"></i>{{ i18n.t(segment.labelKey) }} <strong>{{ scoreComponentFormula(segment) }}</strong></span>
            }
          </div>
        </section>

        <section class="score-panel sentiment-panel sentiment-chart">
          <div class="score-panel-heading"><span>{{ i18n.t('dashboard.scoreModal.sentimentTitle') }}</span><strong>{{ i18n.t('dashboard.scoreModal.sentimentSubtitle') }}</strong></div>
          <p class="score-ratio-summary">{{ i18n.t('dashboard.scoreModal.likeDislikeRatio', { likes: selectedScoreContributor.receivedLikeCount, dislikes: selectedScoreContributor.receivedDislikeCount, percent: sentimentPositivePercent(selectedScoreContributor) }) }}</p>
          <div class="sentiment-donut-layout">
            <div class="sentiment-donut" role="img" [attr.aria-label]="i18n.t('dashboard.scoreModal.sentimentChartLabel')" [style.--positive-percent]="sentimentPositivePercent(selectedScoreContributor) + '%'">
              <div class="sentiment-donut-center"><strong>{{ sentimentPositivePercent(selectedScoreContributor) }}%</strong><span>{{ i18n.t('dashboard.scoreModal.positive') }}</span></div>
            </div>
            <div class="chart-legend vertical">@for (segment of sentimentSegments(selectedScoreContributor); track segment.key) { <span [class]="'legend-item ' + segment.kind"><i></i>{{ i18n.t(segment.labelKey) }}: <strong>{{ segment.value }}</strong> ({{ chartPercentLabel(segment.width) }})</span> }</div>
          </div>
        </section>

        <section class="score-panel activity-panel activity-chart">
          <div class="score-panel-heading"><span>{{ i18n.t('dashboard.scoreModal.activityTitle') }}</span><strong>{{ i18n.t('dashboard.scoreModal.activitySubtitle') }}</strong></div>
          <div class="activity-comparison" role="img" [attr.aria-label]="i18n.t('dashboard.scoreModal.activityChartLabel')">
            @for (segment of activitySegments(selectedScoreContributor); track segment.key) {
              <div class="activity-comparison-row">
                <span>{{ i18n.t(segment.labelKey) }} <strong>({{ segment.value }})</strong></span>
                <div class="activity-bar-track"><div class="activity-bar" [class.positive]="segment.kind === 'positive'" [class.neutral]="segment.kind === 'neutral'" [style.width.%]="segment.width"><strong>{{ chartPercentLabel(segment.width) }}</strong></div></div>
              </div>
            }
          </div>
        </section>

        <section class="score-panel user-contributions-panel">
          <div class="score-panel-heading"><span>{{ i18n.t('dashboard.scoreModal.contributionsTitle') }}</span><strong>{{ selectedScoreContributor.contributions?.length ?? 0 }}</strong></div>
          <div class="user-contribution-list">
            @for (contribution of selectedScoreContributor.contributions ?? []; track contribution.offerId + contribution.field + contribution.value) {
              <article class="user-contribution-row">
                <div class="user-contribution-main">
                  <button class="user-contribution-offer-link" type="button" (click)="openOfferDetailFromContributionSummary(contribution)">
                    <i class="bi bi-window-sidebar me-1" aria-hidden="true"></i>{{ contributionOfferLabel(contribution) }}
                  </button>
                  <span class="user-contribution-field">{{ contributionFieldLabel(contribution.field) }}</span>
                  <strong>{{ contribution.value }}</strong>
                  <small>{{ contributionSummaryStats(contribution) }}</small>
                </div>
                <div class="user-contribution-ratio" [attr.aria-label]="i18n.t('dashboard.scoreModal.likeDislikeRatio', { likes: contribution.voteCount, dislikes: contribution.dislikeCount, percent: sentimentPositivePercent({ receivedLikeCount: contribution.voteCount, receivedDislikeCount: contribution.dislikeCount, proposalCount: 0, voteCount: 0, reactionCount: 0, reviewCount: 0, score: contribution.score, rank: 0, username: '', displayName: '' }) })">
                  <span class="positive"><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i>{{ contribution.voteCount }}</span>
                  <span class="negative"><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i>{{ contribution.dislikeCount }}</span>
                </div>
              </article>
            } @empty {
              <p class="text-secondary mb-0">{{ i18n.t('dashboard.scoreModal.noContributions') }}</p>
            }
          </div>
        </section>
      </div>
    </div>
  </div>
}

@if (showAddTierOfferModal) {
  <div class="modal-backdrop-custom" [class.modal-is-opening]="!isModalClosing('addTierOffer')" [class.modal-is-closing]="isModalClosing('addTierOffer')" (click)="closeAddTierOfferModal()"></div>
  <div class="calendar-modal search-modal" [class.modal-is-opening]="!isModalClosing('addTierOffer')" [class.modal-is-closing]="isModalClosing('addTierOffer')" role="dialog" aria-modal="true" aria-labelledby="addTierOfferModalTitle">
    <div class="soft-card bg-white modal-card-shell">
      <div class="modal-fixed-header d-flex justify-content-between align-items-start gap-3">
        <div>
          <h2 id="addTierOfferModalTitle" class="h4 mb-1">{{ i18n.t('dashboard.addOfferToTierList') }}</h2>
          <p class="text-secondary mb-0">{{ i18n.t('dashboard.tierListOnlyNew') }}</p>
        </div>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="closeAddTierOfferModal()" [disabled]="isAddingTierOffer" [attr.aria-label]="i18n.t('dashboard.closeAddTierOfferModal')"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="modal-scroll-body">
      <label class="form-label tier-add-select mb-3">
        {{ i18n.t('common.tier') }}
        <select class="form-select" [(ngModel)]="selectedTierForNewOffer" name="selectedTierForNewOffer" [disabled]="isAddingTierOffer">
          @for (tier of tierLanes; track tier.id) {
            <option [ngValue]="tier.id">{{ tier.name }}</option>
          }
        </select>
      </label>
      <label class="form-label tier-add-select mb-3">
        {{ i18n.t('dashboard.searchTierOffers') }}
        <input class="form-control" type="search" [(ngModel)]="tierOfferSearch" name="tierOfferSearch" [placeholder]="i18n.t('dashboard.searchTierOffersPlaceholder')" [disabled]="isAddingTierOffer">
      </label>
      <div class="tier-add-list">
        @for (offer of availableTierOffers; track offer.id) {
          <button class="tier-add-option" type="button" (click)="addOfferToTierList(offer.id)" [disabled]="isAddingTierOffer" [attr.aria-busy]="isAddingTierOffer">
            <strong class="tier-add-offer-title">
              {{ offer.title }}
              <span class="tier-add-offer-modal-link" role="link" tabindex="0" (click)="$event.stopPropagation(); openOfferDetailFromModal(offer)" (keyup.enter)="$event.stopPropagation(); openOfferDetailFromModal(offer)">{{ i18n.t('dashboard.openOfferModal') }}</span>
            </strong>
            <span>
              @if (isAddingTierOffer) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>{{ i18n.t('dashboard.addingOfferToTierList') }} }
              @else {
                {{ offer.university }} ·
                @for (country of countryFlagItems(offer); track country.code) { <img class="country-flag" [src]="country.flagUrl" [alt]="country.name" [title]="country.name" loading="lazy"> }
                @if (!isMultipleCountries(offer.country)) { {{ countryDisplayName(offer.country) }} · }
                {{ i18n.t('dashboard.fitValue', { fit: offer.fitScore }) }}
              }
            </span>
          </button>
        } @empty {
          <p class="text-secondary mb-0">{{ i18n.t('dashboard.noAvailableOffers') }}</p>
        }
      </div>
      </div>
    </div>
  </div>
}

@if (tierContextMenu) {
  <button class="tier-context-menu" type="button" [style.left.px]="tierContextMenu.x" [style.top.px]="tierContextMenu.y" (click)="removeOfferFromTierList()" (mouseleave)="closeTierContextMenu()">
    <i class="bi bi-trash me-2"></i>{{ i18n.t('dashboard.removeFromTierList') }}
  </button>
}

@if (selectedOffer) {
  <div class="modal-backdrop-custom" [class.modal-is-opening]="!isModalClosing('calendar')" [class.modal-is-closing]="isModalClosing('calendar')" (click)="closeCalendarModal()"></div>
  <div class="calendar-modal" [class.modal-is-opening]="!isModalClosing('calendar')" [class.modal-is-closing]="isModalClosing('calendar')" role="dialog" aria-modal="true" aria-labelledby="calendarModalTitle">
    <div class="soft-card bg-white modal-card-shell">
      <div class="modal-fixed-header d-flex justify-content-between align-items-start gap-3">
        <div>
          <h2 id="calendarModalTitle" class="h4 mb-1">{{ i18n.t('dashboard.addDeadlineToCalendar') }}</h2>
          <p class="text-secondary mb-0">{{ selectedOffer.title }} · {{ formatOfferDeadline(selectedOffer.deadline) }}</p>
        </div>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="closeCalendarModal()" [attr.aria-label]="i18n.t('dashboard.closeCalendarModal')"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="modal-scroll-body">
      <p>{{ i18n.t('dashboard.calendarExportText') }}</p>
      <div class="d-flex flex-column flex-sm-row gap-2">
        <button class="btn btn-primary" type="button" (click)="downloadIcs()" [disabled]="isDownloadingIcs" [attr.aria-busy]="isDownloadingIcs">
          @if (isDownloadingIcs) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> } @else { <i class="bi bi-calendar-plus me-2"></i> }
          {{ isDownloadingIcs ? i18n.t('dashboard.preparingIcs') : i18n.t('dashboard.downloadIcs') }}
        </button>
        <button class="btn btn-outline-secondary" type="button" (click)="closeCalendarModal()">{{ i18n.t('common.cancel') }}</button>
      </div>
      </div>
    </div>
  </div>
}